import { useQuery } from '@tanstack/react-query';

import type { ApiError } from '@/types/api.types';

import { getSystemSpecialties } from '../api/specialtiesApi';
import type { SystemSpecialtyListData } from '../types';

const lang = import.meta.env.VITE_APP_LOCALE ?? 'en';

export function useSystemSpecialties() {
  const query = useQuery<SystemSpecialtyListData, ApiError>({
    queryKey: ['system-specialties', lang],
    queryFn: () => getSystemSpecialties(lang),
    staleTime: 5 * 60 * 1000,
  });

  return {
    systemSpecialties: query.data?.specialties ?? [],
    isLoading: query.isLoading,
    fetchError: query.error,
  };
}
